import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { BeforeAfter } from './components/BeforeAfter';
import { PainPoints } from './components/PainPoints';
import { Tomos } from './components/Tomos';
import { Deliverables } from './components/Deliverables';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { About } from './components/About';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
import { FloatingCta } from './components/FloatingCta';
import { PurchasePopup } from './components/PurchasePopup';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-cream font-sans text-navy-900" data-id="element-0" data-mp="23vkvuhy9gblr">
      <Hero data-id="element-1" data-mp="23v2tr4ox335x" />
      <main data-id="element-2" data-mp="23ti8k5ohswkq">
        <Stats data-id="element-3" data-mp="3ijxokogyjwiu" />
        <BeforeAfter data-id="element-4" data-mp="3ikha0f5th31m" />
        <PainPoints data-id="element-5" data-mp="3iiwaeb4natww" />
        <Tomos data-id="element-6" data-mp="3ijpbavgxap74" />
        <Deliverables data-id="element-7" data-mp="3ihuyy5jpw5en" />
        <Bonuses data-id="element-8" data-mp="3mlaxx8j9ehui" />
        <Offer data-id="element-9" data-mp="3mkrbpfmkt7ao" />
        <Guarantee data-id="element-10" data-mp="3mk85uxa7a9d0" />
        <Testimonials data-id="element-11" data-mp="3mjq2zht18ww4" />
        <About data-id="element-12" data-mp="3mj6lu3b7icj5" />
        <Faq data-id="element-13" data-mp="3rcj846sey78q" />
      </main>
      <Footer data-id="element-14" data-mp="3rdaselgk8ijp" />
      <FloatingCta data-id="element-15" data-mp="3rcsyhvhdegey" />
      <PurchasePopup data-id="element-16" data-mp="3recd7hndojem" />
    </div>;
}